<template>
    <transition
        name="expand"
        enter-active-class="expandIn"
        leave-active-class="expandOut"
        v-bind="$attrs"
        v-on="hooks"
    >
        <slot></slot>
    </transition>
</template>
<script>
export default {
    name: 'expand-transition',
    props: {
        duration: {
            type: Number,
            default: 500,
        },
        origin: {
          type: String,
          default: 'top center'
        }
    },
    computed: {
        hooks() {
            return {
                beforeEnter: this.setup,
                afterEnter: this.cleanup,
                beforeLeave: this.setup,
                afterLeave: this.cleanup,
                ...this.$listeners,
            };
        },
    },
    methods: {
        setup(el) {
            el.style.transformOrigin = this.origin;
            el.style.animationDuration = `${this.duration}ms`;
        },
        cleanup(el) {
            el.style.maxHeight = null;
            el.style.animationDuration = "";
            el.style.transformOrigin = "";
        },
    },
};
</script>
<style>
@keyframes expandIn {
    from {
        opacity: 0;
        max-height: 0;
        transform: scale(0);
    }
    to {
        opacity: 1;
        max-height: 100vh;
        transform: scale(1);
    }
}
.expandIn {
    animation-name: expandIn;
}
@keyframes expandOut {
    from {
        opacity: 1;
        max-height: 100vh;
        transform: scale(1);
    }
    to {
        opacity: 0;
        max-height: 0vh;
        transform: scale(0);
    }
}
.expandOut {
    animation-name: expandOut;
}

.expand-enter-active {
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.expand-leave-active {
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
</style>